import React from 'react';
import './About.css';

const MEMBERS = [
  { name: 'Gene Smith', role: 'Vocals, Guitar' },
  { name: 'Curtis Harvey', role: 'Guitar' },
  { name: 'Amy Weaver', role: 'Vocals, Bass' },
  { name: 'Steve DeCristofaro', role: 'Drums' },
];

export default function About() {
  return (
    <div className="about">
      <div className="section-container">
        <h1 className="section-title">About</h1>
        <div className="section-rule" />

        <div className="about-layout">
          <div className="about-photo">
            <img src="/images/band-photo.jpg" alt="Echo Hill" />
            <div className="about-photo-border" />
          </div>

          <div className="about-bio">
            <p className="about-bio-lead">
              Echo Hill blends atmospheric alternative rock, desert groove, and cinematic progressive
              dynamics into emotionally immersive heavy soundscapes.
            </p>
            <p>
              Built by veteran members of the Sacramento music scene, the band leans into mood, texture,
              and tension as much as riff and volume, balancing hypnotic grooves with layered guitars,
              expansive melodies, and moments of controlled intensity.
            </p>
            <p>
              Equal parts introspective and driving, Echo Hill's sound lives somewhere between
              late-night headphones and wide-open highway energy, exploring themes of reflection,
              disconnection, and resilience through modern atmospheric rock.
            </p>

            <div className="about-members">
              {MEMBERS.map(({ name, role }) => (
                <div key={name} className="about-member">
                  <span className="about-member-name">{name}</span>
                  <span className="about-member-role">{role}</span>
                </div>
              ))}
            </div>

            <p>
              Check out our debut album on Bandcamp and catch us live — dates are always up on the
              Shows page.
            </p>

            <div className="about-links">
              <a href="https://echohillband.bandcamp.com/album/echo-hill" target="_blank" rel="noopener noreferrer" className="about-cta">
                Stream on Bandcamp
              </a>
              <a href="https://www.facebook.com/weareechohill/events" target="_blank" rel="noopener noreferrer" className="about-cta about-cta--outline">
                Upcoming Shows
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
